// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"210":"d96e4f57cb889f36d56c","581":"283b9af27189c45efc84"}[chunkId] + ".bundle.js";
};